var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
var Ng1FileDropDirective = /** @class */ (function (_super) {
    __extends(Ng1FileDropDirective, _super);
    function Ng1FileDropDirective(elementRef, injector) {
        var _this = _super.call(this, 'fileDrop', elementRef, injector) || this;
        _this.refresh = new EventEmitter();
        return _this;
    }
    return Ng1FileDropDirective;
}(UpgradeComponent));
export { Ng1FileDropDirective };
var Ng1FileDropPlayerDirective = /** @class */ (function (_super) {
    __extends(Ng1FileDropPlayerDirective, _super);
    function Ng1FileDropPlayerDirective(elementRef, injector) {
        var _this = _super.call(this, 'fileDropPlayer', elementRef, injector) || this;
        _this.refresh = new EventEmitter();
        _this.remove = new EventEmitter();
        return _this;
    }
    return Ng1FileDropPlayerDirective;
}(UpgradeComponent));
export { Ng1FileDropPlayerDirective };
